import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs';

import {
  AdminProjectActionTypes,
  AdminProjectsClear,
  AdminProjectsLoad,
  AdminProjectsLoadFail,
  AdminProjectsLoadSuccess,
} from '@completion/actions';
import { AdminProjectDto } from '@completion/models';
import { State } from '@completion/reducers';
import { NotificationService } from '@completion/services';
import { AdminFormService } from '../../services/admin-form.service';
import { trackResource } from './resource-fetch.util';

@Injectable()
export class AdminProjectEffect {
  constructor(
    private actions$: Actions,
    private adminFormService: AdminFormService,
    private store: Store<State>,
    private toastr: NotificationService,
  ) {}

  loadAdminProjects$ = createEffect(() =>
    this.actions$.pipe(
      ofType<AdminProjectsLoad>(AdminProjectActionTypes.AdminProjectsLoad),
      trackResource<AdminProjectDto[]>({
        actions$: this.actions$,
        store: this.store,
        toastr: this.toastr,
        service: this.adminFormService,
        method: 'getAdminProjects',
        serviceArgs: () => [],
        onSuccess: (response) => new AdminProjectsLoadSuccess(response),
        onError: (error) => new AdminProjectsLoadFail(error),
      }),
    ),
  );

  clearAdminProjects$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<AdminProjectsClear>(AdminProjectActionTypes.AdminProjectsClear),
        tap(() => this.adminFormService.invalidateAdminProjects()),
      ),
    { dispatch: false },
  );
}
